import { render, staticRenderFns } from "./StatusWidget.vue?vue&type=template&id=86161d0c&"
import script from "./StatusWidget.vue?vue&type=script&lang=js&"
export * from "./StatusWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports